export default __webpack_public_path__ + "static/media/A001inaz.4f2c7920.jpg";